import { Helmet } from 'react-helmet';
import RegisterEntityStepForm from './RegisterEntityStepForm/RegisterEntityStepForm';

export default () => {
  return (
    <>
      <Helmet>
        <title>Inscription</title>
      </Helmet>
      <RegisterEntityStepForm />
    </>
  );
};
